import { Action } from 'redux';

import { STORE, CLEAR } from './constants';
import Auth from './model';
import { StoreAction } from './actions';

const initialState = new Auth();

export default (state = initialState, action: Action) => {
  switch (action.type) {
    case STORE: {
      const { token } = action as StoreAction;

      return state.set('token', token);
    }

    case CLEAR:
      return initialState;

    case 'RESET':
      return initialState;

    default:
      return state;
  }
};
